import "./App.css";
import { Account, Explore, CoachDetail } from "./pages";
import { TopicDetail } from "./pages";
import { Bookings } from "./pages";
import { Messages } from "./pages";
import { Settings } from "./pages";
import { Favorites } from "./pages";
import { Signup } from "./pages";
import { Wallet, VideoRoom, Faq } from "./pages";
import { SideMenu, ToastProvider } from "./components";
import { Space } from "antd";
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { getAccessToken } from "./cookies";

const AppContent = () => {
  const location = useLocation();
  const isAuthenticated = !!getAccessToken();
  const hideSideMenu =
    location.pathname === "/signup" ||
    location.pathname === "/signin" ||
    location.pathname === "/" ||
    location.pathname === "/faq" ||
    location.pathname.startsWith("/video-room/");

  // When the side menu is hidden (signin/signup), ensure the
  // menu-expanded class is removed so the page content isn't offset.
  useEffect(() => {
    const pageContainer = document.querySelector(".page-container");
    if (pageContainer && hideSideMenu) {
      pageContainer.classList.remove("menu-expanded");
    }
  }, [hideSideMenu]);

  return (
    <div className="App">
      {!hideSideMenu && <SideMenu />}
      <div className={`page-container${hideSideMenu ? " no-side-menu" : ""}`}>
        <Space
          direction="vertical"
          size="large"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Routes>
            <Route
              path="/"
              element={
                isAuthenticated ? (
                  <Navigate to="/explore" replace />
                ) : (
                  <Navigate to="/signup" replace />
                )
              }
            />
            <Route path="/account" element={<Account />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/topic/:topicId" element={<TopicDetail />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/coach/:coachId" element={<CoachDetail />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/signin" element={<Navigate to="/signup" replace />} />
            <Route path="/video-room/:appointmentId" element={<VideoRoom />} />
          </Routes>
        </Space>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </Router>
  );
};

export default App;
